module.exports = __webpack_public_path__ + "static/media/platform2.1790cd68.png";